<template>
  <div class="vb-checkout">
    <pratica
      :services="quote.services"
      :passengers="passengers.passengers"
    />
  </div>
</template>

<script>
import Pratica from "@alpitour/components/blocks/pratica.vue";
export default {
  name: "checkout-block",
  props: {
    quote: {},
    passengers: [],
  },
  components: {
    pratica: Pratica,
  },
};
</script>
